<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Centro de gasto</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Centro de gasto</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="muestraModalAgrega(); showModalAgregar()" size="sm"
        mdbWavesEffect>
        Agregar
      </button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px">
        <div class="md-form">
          <div class="md-form">
            <input value="" type="text" id="nomb" class="form-control" placeholder="Nombre" required
              [(ngModel)]="nombreBusquedaCG" #nomb />
            <label for="nomb">Nombre</label>
          </div>
        </div>
      </div>
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="1" mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="filtraxEstado();">
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cg of listaCentroGasto">
            <td>{{cg.nombre}}</td>
            <td>
              <mdb-badge pill="true" *ngIf="cg.activado" success="true">Activo</mdb-badge>

              <mdb-badge pill="true" *ngIf="!cg.activado" warning="true">Inactivo</mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" placement="right" (click)="showForEdit(cg);showModalModificar()">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button *ngIf="!cg.activado" (click)="permitirCambioEstado(cg)" class="btn-actions-sm" color="primary"
                mdbBtn type="button" mdbWavesEffect mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="cg.activado" class="btn-actions-sm" (click)="permitirCambioEstado(cg)" color="success"
                mdbBtn type="button" mdbWavesEffect mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar motivo -->
<div mdbModal style="overflow-y: auto" #agregarCentroGasto="mdb-modal" class="modal fade" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="agregarCentroGasto.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formAgregarCentroGasto">
            <div class="container">
              <div class="row">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos del Centro de gasto
                  </h5>
                </div>
                <div class="col">
                  <div class="switch info-switch">
                    <label>Inactivo<input type="checkbox" color="info" checked="" formControlName="activado" /><span
                        class="lever"></span> Activo
                    </label>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="nombre" class="form-control" placeholder="Nombre" required #nombre
                      formControlName="nombre" />
                    <label for="nombre">Nombre</label>
                    <div *ngIf="
                        formAgregarCentroGasto.invalid &&
                        (formAgregarCentroGasto.dirty || formAgregarCentroGasto.touched)
                      ">
                      <mdb-error *ngIf="formAgregarCentroGasto.get('nombre').hasError('required')">
                        El nombre es requerido
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroGasto.get('nombre').hasError('maxlength')">
                        El nombre debe tener como máximo 20 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroGasto.get('nombre').hasError('minlength')">
                        El nombre debe tener como mínimo 5 caracteres
                      </mdb-error>
                    </div>
                  </div>
                  <div class="md-form">
                    <input value="" type="text" id="descripcion" class="form-control" placeholder="Descripción" required
                      #descripcion formControlName="descripcion" />
                    <label for="descripcion">Descripción</label>
                    <div *ngIf="
                        formAgregarCentroGasto.invalid &&
                        (formAgregarCentroGasto.dirty || formAgregarCentroGasto.touched)
                      ">
                      <mdb-error *ngIf="formAgregarCentroGasto.get('descripcion').hasError('required')">
                        La descripción es requerida
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroGasto.get('descripcion').hasError('maxlength')">
                        La descripción debe tener como máximo 100 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formAgregarCentroGasto.get('descripcion').hasError('minlength')">
                        La descripción debe tener como mínimo 3 caracteres
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="agregarCentroGasto.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit"
            (click)="insertar();agregarCentroGasto.hide();" [disabled]="!formAgregarCentroGasto.valid">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL Editar motivo -->
<div mdbModal style="overflow-y: auto" #editarCentroGasto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="editarCentroGasto.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="formEditarCentroGasto">
            <div class="container">
              <div class="row">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos del Centro de gasto
                    <input type="hidden" name="codigox" id="codigox" formControlName="codigo" />
                  </h5>
                </div>
                <div class="col">
                  <div class="switch info-switch">
                    <label>Inactivo<input type="checkbox" color="info" checked="" formControlName="activado" /><span
                        class="lever"></span> Activo
                    </label>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="nombrex" class="form-control" placeholder="Nombre" required #nombrex
                      formControlName="nombre" />
                    <label for="nombrex">Nombre</label>
                    <div *ngIf="
                        formEditarCentroGasto.invalid &&
                        (formEditarCentroGasto.dirty || formEditarCentroGasto.touched)
                      ">
                      <mdb-error *ngIf="formEditarCentroGasto.get('nombre').hasError('required')">
                        El nombre es requerido
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroGasto.get('nombre').hasError('maxlength')">
                        El nombre debe tener como máximo 20 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroGasto.get('nombre').hasError('minlength')">
                        El nombre debe tener como mínimo 5 caracteres
                      </mdb-error>
                    </div>
                  </div>
                  <div class="md-form">
                    <input value="" type="text" id="descripcionx" class="form-control" placeholder="Descripción"
                      required #descripcionx formControlName="descripcion" />
                    <label for="descripcionx">Descripción</label>
                    <div *ngIf="
                        formEditarCentroGasto.invalid &&
                        (formEditarCentroGasto.dirty || formEditarCentroGasto.touched)
                      ">
                      <mdb-error *ngIf="formEditarCentroGasto.get('descripcion').hasError('required')">
                        La descripción es requerida
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroGasto.get('descripcion').hasError('maxlength')">
                        La descripción debe tener como máximo 100 caracteres
                      </mdb-error>
                      <mdb-error *ngIf="formEditarCentroGasto.get('descripcion').hasError('minlength')">
                        La descripción debe tener como mínimo 3 caracteres
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="editarCentroGasto.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit"
            (click)="actualizar();editarCentroGasto.hide();" [disabled]="!formEditarCentroGasto.valid">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>